import React from 'react';
import { useWebLocale } from '../../contexts/WebLocaleContext';

// A failed refresh must not hide usable cards or silently look like fresh data.
export default function ExploreState({ query, fallback, children }) {
  const { t } = useWebLocale();
  const available = query.data != null || fallback != null;
  return (
    <>
      {query.isError && (
        <div role="alert" className="pp-browse-list-status">
          <span>{t('error')}</span>
          <button
            type="button"
            className="pp-action"
            disabled={query.isFetching}
            onClick={() => query.refetch({ cancelRefetch: false })}
          >
            {t('retry')}
          </button>
        </div>
      )}
      {query.isPending && !available && <p role="status">{t('loading')}…</p>}
      {available && children}
    </>
  );
}
